import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { DateTime } from 'luxon';
import { Heading, VStack } from '@library';
import Button from '../../../core/components/Button';
import DownloadArrowIcon from '../../../core/components/icons/DownloadArrowIcon';
import StoryblokRender from '../../../content/components/StoryblokRender';
import type { PostStory } from '../../../content/types/types';
import StoryblokResponsiveImage from '../../../content/components/PageComponents/StoryblokResponsiveImage';
import styles from './PostPageContent.module.scss';

const PostPageContent = ({ post }: { post: PostStory }) => {
    const date = DateTime.fromISO(post.first_published_at).toFormat(
        'dd.MM.yyyy'
    );
    return (
        <div className={styles.container}>
            <StoryblokResponsiveImage
                loading="lazy"
                className={styles.image}
                predefinedSet="fullWidth"
                onlyFocusCrop
                predefinedDefaultHeight={450}
                image={post.content.featured_image}
            />

            <div className={styles.content}>
                <p className={styles.date}>{date}</p>
                <div className={styles.header}>
                    <Heading h1>{post.content.title}</Heading>
                </div>

                <div className={styles.contentRender}>
                    <VStack gap="small">
                        <StoryblokRender
                            components={post.content.body}
                            scrollToElement
                        />
                    </VStack>
                </div>

                {post.content.attachments &&
                    post.content.attachments.length > 0 && (
                        <div className={styles.downloadLinksContainer}>
                            <p className={styles.downloadTitle}>
                                <FormattedMessage id="downloads" />
                            </p>
                            <div className={styles.buttonContainer}>
                                {post.content.attachments.map(link => (
                                    <a
                                        className={styles.link}
                                        href={link.target.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        download={link.label}
                                        key={link.target.url}
                                    >
                                        <Button secondary>
                                            {link.label}
                                            <span className={styles.icon}>
                                                <DownloadArrowIcon />
                                            </span>
                                        </Button>
                                    </a>
                                ))}
                            </div>
                        </div>
                    )}
            </div>
        </div>
    );
};

export default memo(PostPageContent);
